import { useEffect, useState, useContext, useRef } from 'react'
//Context
import { I18nContext } from '../context/I18nProvider'
//I18n
import Translate from '../i18n/Translate'
import { useTranslation } from 'react-i18next'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
//Accordion
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion'
import OperatorsGallery from '../components/OperatorsGallery'
//Components
import ShortArrow from '../components/svg/ShortArrow'
//Images
import lupa from '../assets/images/Lupa.svg'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'

const Faqs = () => {
    useScrollTop()
    useSetI18nProviderInformation('faqs')

    const { t } = useTranslation()
    const faqsSectionRef = useRef()
    const searchInputRef = useRef()

    const { language } = useContext(I18nContext)

    const [faqs, setFaqs] = useState([])
    const [noSearchsFound, setNoSearchsFound] = useState(false)

    const handleSearch = (e) => {
        e.preventDefault()
        const querySearch = searchInputRef.current.value
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[^\w\s.-_]/g, '')

        //faqs[0], faqs[1], faqs[2]
        const sections = [...faqsSectionRef.current.children]

        if (querySearch) {
            let questionIndex

            //Ciclo for para cortar cuando ya se encontro busqueda
            for (let j = 0; j < faqs.length; j++) {
                questionIndex = search(faqs[j])

                if (questionIndex !== false) {
                    findQuestion(questionIndex, j)
                    break
                }
            }
            //si no encuentra ningún resultado, muestra un mensaje
            if (questionIndex === false) {
                setNoSearchsFound(true)
            }
        }

        function search(array) {
            const lowerCaseQuestions = []
            const lowerCaseAnswers = []

            array.forEach((element) => {
                //saca las mayúsculas y las tildes
                lowerCaseQuestions.push(
                    element.question
                        .toLowerCase()
                        .normalize('NFKD')
                        .replace(/[^\w\s.-_]/g, '')
                )
                lowerCaseAnswers.push(
                    element.answer
                        .toLowerCase()
                        .normalize('NFKD')
                        .replace(/[^\w\s.-_]/g, '')
                )
            })

            //busca el elemento que incluye la búsqueda
            const searchQuestion = lowerCaseQuestions.find((el) => el.includes(querySearch))
            const searchAnswer = lowerCaseAnswers.find((el) => el.includes(querySearch))

            if (searchQuestion) {
                //si encuentra una coincidencia entre las preguntas, devuelve el índice
                return lowerCaseQuestions.indexOf(searchQuestion)
            } else if (searchAnswer) {
                //si encuentra una coincidencia entre las respuestas, devuelve el índice
                return lowerCaseAnswers.indexOf(searchAnswer)
            } else {
                return false
            }
        }

        function findQuestion(questionIndex, sectionIndex) {
            let sectionQuestions = [...sections[sectionIndex].children] //Seccion especifica => (Info util de Argentina, Faqs, Viaje Responsable)

            //preguntas de la sección[i]
            let allQuestions = [...sectionQuestions[1].children] //Todas los Accordion items, las preguntas de la seccion.
            let foundQuestion = allQuestions[questionIndex] //Las seccion donde se encuentra la pregunta encontrada por el indice pasado por parametro
            let answerToShow = foundQuestion.childNodes[1]

            //abre la respuesta
            if (answerToShow.hasAttribute('hidden')) {
                answerToShow.ariaHidden = 'false'
                answerToShow.removeAttribute('hidden')
            }

            //gira el botón cuando se abre que depende del atributo desde CSS
            let button = foundQuestion.childNodes[0].childNodes[0]
            button.ariaExpanded = 'true'

            //scroll hasta la respuesta
            let headerHeight = document.querySelector('header').offsetHeight
            foundQuestion.style.scrollMarginTop = headerHeight + 'px'
            foundQuestion.scrollIntoView()
        }
    }

    //Hago fetch a los locales con el lenguaje seleccionado para traer los faqs y ponerlos en un array para iterarlos
    useEffect(() => {
        if (language !== undefined) {
            fetch(`${process.env.PUBLIC_URL}/locales/${language}/translation.json`)
                .then((data) => data.json())
                .then(({ faqs }) => {
                    if (faqs.data) {
                        let faqsArray = []
                        let keys = Object.keys(faqs.data)
                        keys.forEach((key) => {
                            faqsArray.push(faqs.data[key].aqs)
                        })
                        setFaqs(faqsArray)
                    }
                })
                .catch((e) => console.log(e))
        }
    }, [language])

    return (
        <main className="incoming-faqs">
            <section className="incoming-faqs__top">
                <h1 className="title top-title animate slide-title in-view">
                    <Translate langkey="faqs.title" />
                </h1>

                <form className="faqs-search" onSubmit={handleSearch}>
                    <input
                        type="search"
                        className="faqs-search__search"
                        placeholder={t('faqs.searchBar.placeholder')}
                        ref={searchInputRef}
                        onKeyDown={() => setNoSearchsFound(false)}
                    />
                    <button type="submit" className="faqs-search__btn" aria-label={t('faqs.searchBar.ariaLabelBtn')}>
                        <img src={lupa} alt="" />
                    </button>
                    {noSearchsFound && (
                        <span className="faqs-search__not-found" aria-invalid="true">
                            <Translate langkey="faqs.searchBar.notFound" />
                        </span>
                    )}
                </form>
            </section>

            <section className="incoming-faqs__aq" ref={faqsSectionRef}>
                <section className="useful-info-argentina">
                    <h2>
                        <Translate langkey="faqs.data.useful_info_argentina.title" />
                    </h2>
                    <Accordion allowMultipleExpanded allowZeroExpanded>
                        {faqs.length > 0 &&
                            faqs[0].map((faq) => (
                                <AccordionItem key={faq.question}>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            <span>{faq.question}</span>
                                            <div className="arrow-wrapper">
                                                <ShortArrow />
                                            </div>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            ))}
                    </Accordion>
                </section>

                <section className="frequently-asked-questions">
                    <h2>
                        <Translate langkey="faqs.data.faqs.title" />
                    </h2>
                    <Accordion allowMultipleExpanded allowZeroExpanded>
                        {faqs.length > 0 &&
                            faqs[1].map((faq) => (
                                <AccordionItem key={faq.question}>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            <span>{faq.question}</span>
                                            <div className="arrow-wrapper">
                                                <ShortArrow />
                                            </div>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            ))}
                    </Accordion>
                </section>

                <section className="responsible-travel">
                    <h2>
                        <Translate langkey="faqs.data.responsible_travel.title" />
                    </h2>
                    <h5>
                        <Translate langkey="faqs.data.responsible_travel.copy" />
                    </h5>
                    <Accordion allowMultipleExpanded allowZeroExpanded>
                        {faqs.length > 0 &&
                            faqs[2].map((faq) => (
                                <AccordionItem key={faq.question}>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            <span>{faq.question}</span>
                                            <div className="arrow-wrapper">
                                                <ShortArrow />
                                            </div>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            ))}
                    </Accordion>
                </section>
            </section>
            <OperatorsGallery />
        </main>
    )
}

export default Faqs
